import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import { reqIdleCallback, isInWindmillByMY } from './utils';
import { isPromise } from './promise/index';
var AES = {}; // 三方小程序

/*
1. GET、WS：ok
2. UT：4w
3. POST：连续调用会pending
4. sendBeacon：累计64KB限制，aplus现在没有做限制，存在风险
4. 小程序
    1. UT：淘宝iOS 4w、淘宝Android 4w
    2. GET：支付宝iOS 6w、支付宝Android 7000、小程序IDE 7000
5. 浏览器：
    1. Android Chrome GET：64928
    2. iOS safari GET：
*/

var CONFIG_MAX_URL_LIMIT = 'maxUrlLength';
var MINIAPP_LENGTH = 5000;
var WEB_LENGTH = 35000;
var URL_LIMIT = isInWindmillByMY() ? MINIAPP_LENGTH : WEB_LENGTH;
var queue = [];
var requiredFieldQueue = [];
var CONFIG_REQUIREDFIELDS = 'requiredFields';
var SDK_VERSION = "1.0.34";

var getPVID = function getPVID() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  var current = arguments.length > 1 ? arguments[1] : undefined;
  current = current ? current : '';
  return length ? getPVID(--length, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.charAt(Math.floor(Math.random() * 60)) + current) : current;
};

var AES_CONFIG = {
  sdk_version: SDK_VERSION,
  pv_id: getPVID()
};
/**
 * 发送队列中的所有埋点
 * @method sendAll
 */

function sendAll() {
  if (!queue.length) {
    return;
  } // 如果一次能发送完


  var fullData = queue.join('|'); // 设置成POST后，也不能完全放开，例如aplus在新版本会走ws发送，服务端限制了6000字符
  // if(
  //     // 没有关闭并且已经加载aplus脚本的时候才可以走POST，否则可能走img的get请求
  //     //(typeof AES_DISABLE_POST === 'undefined' || AES_DISABLE_POST === false) &&
  //     AES_CONFIG.method !== 'get' ||
  //     // TODO: 这个判断只适用于web，需要考虑小程序等场景
  //     typeof goldlog !== 'undefined' && typeof goldlog.record === 'function'
  // ){
  //     URL_LIMIT = 5300;
  // }

  URL_LIMIT = AES_CONFIG[CONFIG_MAX_URL_LIMIT] || URL_LIMIT;

  if (fullData.length < URL_LIMIT) {
    queue = [];
    AES.send(processData(fullData));
    return;
  } // 否则


  var data = '';

  while (queue.length) {
    var item = queue[0]; // 如果1条记录就超过长度的话还是发送

    if (data && (data + '|' + item).length > URL_LIMIT) {
      break;
    } else {
      queue.shift();
      data += data ? '|' + item : item;
    }
  }

  AES.send(processData(data));

  if (queue.length) {
    sendAll();
  }
}
/**
 * @method send
 * @params dataStr {String} 需要发送的msg信息
 * @params [isCombo] {Boolean} 是否需要combo发送
 */


function send(dataStr, isCombo) {
  if (isCombo === false) {
    reqIdleCallback(function () {
      AES.send(processData(dataStr));
    });
  } else {
    queue.push(dataStr); //queue.push(encodeURIComponent(JSON.stringify(data)));

    reqIdleCallback(sendAll);
  }
}
/**
 * 为埋点增加全局配置参数
 * @method processData
 * @params dataStr {String} 需要发送的msg信息
 */


function processData(dataStr) {
  var r = ['msg=' + dataStr];

  for (var key in AES_CONFIG) {
    // TODO: 需要上报的参数和其它配置放在一起有点麻烦，另外也有风险，可能作为白名单更好一些
    // 插件配置不上报
    key.indexOf('plugin_') === -1 && // requiredFields配置不上报
    key !== CONFIG_REQUIREDFIELDS && // urlMaxLength配置不上报
    key !== CONFIG_MAX_URL_LIMIT && AES_CONFIG.hasOwnProperty(key) && ( // 空字符串、null、undefined不上报
    AES_CONFIG[key] || AES_CONFIG[key] === 0) && r.push(key + '=' + encodeURIComponent(AES_CONFIG[key]));
  }

  return r.join('&');
}
/**
 * 是否有必要参数没有设置好
 * @method isRequiredFieldNotReady
 */


function isRequiredFieldNotReady() {
  // requiredField是否已经存在，pid默认为必要参数
  var requiredFields = (AES_CONFIG[CONFIG_REQUIREDFIELDS] || []).concat(['pid']);
  return requiredFields.some(function (field) {
    return AES_CONFIG[field] === undefined;
  });
}
/**
 * 修改全局配置
 * 
 *      AES.setConfig(key, value)
 *      AES.setConfig({...})
 * 
 * @method AES.setConfig
 * @params key {String|Object} 参数名或者一组参数组成的对象
 * @params [value] {String|Number} 参数值
 */


AES.setConfig = function (key, value) {
  var setConfig = function setConfig() {
    if (value !== undefined) {
      AES_CONFIG[key] = value;
    } else {
      for (var i in key) {
        AES_CONFIG[i] = key[i];
      }
    }
  }; // 有因为必要参数没有Ready而缓存的埋点时，先设置config，然后判断必要参数是否已经ready，如果ready就清空缓存的队列
  // 当存在这样的缓存队列时，所有埋点会携带最后的config信息发送


  if (requiredFieldQueue.length) {
    setConfig();

    if ( // 当前配置项属于必要配置
    // requiredFields.indexOf(k) !== -1 && 
    // 必要配置都已经存在
    !isRequiredFieldNotReady()) {
      requiredFieldQueue.forEach(function (args) {
        send.apply(null, args);
      });
      requiredFieldQueue = [];
    } // 在Config变化前清空历史队列中的埋点，保证埋点发送时会携带最新的config配置

  } else {
    var isConfigChange = function () {
      if (value !== undefined) {
        return value !== AES_CONFIG[key];
      } else {
        for (var i in key) {
          if (key[i] !== AES_CONFIG[i]) {
            return true;
          }
        }
      }

      return false;
    }();

    if (isConfigChange) {
      sendAll();
    }

    setConfig();
  }
};
/**
 * 获取全局配置
 * @method AES.getConfig
 * @params [key] {String} 参数key
 */


AES.getConfig = function (key) {
  return key ? AES_CONFIG[key] : AES_CONFIG;
};
/**
 * 更新pv_id
 * @method AES.updatePVID
 */


AES.updatePVID = function () {
  AES.setConfig('pv_id', getPVID());
};
/**
 * 各个环境需要实现的底层埋点发送方法
 * @interface AES.send
 * @params dataStr {String} 需要发送的`JSON.stringify`后的数据
 */

/**
 * 发送AES埋点
 * @method AES.log
 * @params type {String} 埋点类型
 * @params data {Object} 埋点参数
 * @params [config] {Object} 配置参数
 * @param [config.combo=true] {Boolean} 是否需要合并发送
 */


AES.log = function (type) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!type) {
    return;
  }

  data.ts = data.ts || new Date().getTime();
  data.type = type;
  var qs = [];

  for (var i in data) {
    var v = data[i];

    var _type = Object.prototype.toString.call(v);

    if (_type === '[object String]' || _type === '[object Number]' || _type === '[object Boolean]' || _type === '[object Object]' || _type === '[object Array]') {
      if (_type === '[object Object]' || _type === '[object Array]') {
        v = _JSON$stringify(v);
      }

      qs.push("".concat(i, "=").concat(encodeURIComponent(v)));
    }
  }

  data = encodeURIComponent(qs.join('&')); // requiredField是否已经存在

  if (isRequiredFieldNotReady()) {
    requiredFieldQueue.push([data, config.combo]);
  } else {
    send(data, config.combo);
  }
};
/**
 * AOP能力，在方法执行前先执行某个方法
 * @method AES.before
 * @params originFn {Function} 原始方法
 * @params additionalFn {Function} 需要被追加执行的方法
 */


AES.before = function (originFn, additionalFn) {
  return function () {
    var args = arguments;
    var r = additionalFn.apply(AES, args);

    if (isPromise(r)) {
      r.then(function (parsedArgs) {
        originFn.apply(AES, parsedArgs || args);
      });
    } else {
      originFn.apply(AES, r || args);
    }
  };
};
/**
 * 在AOP能力，方法执行后执行某个方法
 * @method AES.after
 * @params originFn {Function} 原始方法
 * @params additionalFn {Function} 需要被追加执行的方法
 */


AES.after = function (originFn, additionalFn) {
  return function () {
    var args = arguments;
    originFn.apply(AES, args);
    additionalFn.apply(AES, args);
  };
};

export default AES;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker@1.0.34@@ali/aes-tracker/es/core.js
// module id = null
// module chunks = 